import { NavItem, Article, HeroSlide, FooterContent } from './types';

export const NAVIGATION_ITEMS: NavItem[] = [
  { label: 'LATEST', href: '/latest', view: 'latest' },
  { label: 'FRAGMENTS', href: '/fragments', view: 'fragments' },
  { label: 'STANDARD ISSUE', href: '/standard-issue', view: 'standard-issue' },
  { label: 'ARTIFACTS', href: '/artifacts', view: 'artifacts' },
  { label: 'VAULT', href: '/vault', view: 'vault' },
  { label: 'ARCHIVE', href: '/magazine', view: 'magazine' }
];

// Single hero — the archive speaks; it never sells
export const HERO_SLIDES: HeroSlide[] = [
  {
    id: 1,
    image: '/assets/placeholder.svg',
    title: 'There was a summer. No one filmed it.',
    subtitle: 'What remains is being recovered, piece by piece.',
    signOff: '4HVNSK8 — Hastings.'
  }
];

// No fallback articles — the archive shows only what has actually been written
export const ARTICLES: Article[] = [];

// Fallback footer content, used until the admin saves an override in Firestore (content/footer)
export const DEFAULT_FOOTER_CONTENT: FooterContent = {
  newsletterHeading: 'The archive opens 14 August.',
  newsletterText: "Leave an address. You'll know when something surfaces.",
  newsletterSuccessMessage: "You're on the list. When a fragment surfaces, you'll know first.",
  columns: [
    {
      title: 'Shop',
      links: [
        { label: 'Available Now', url: '/shop' },
        { label: 'Fragments', url: '/fragments' },
        { label: 'Standard Issue', url: '/standard-issue' },
        { label: 'Artifacts', url: '/artifacts' },
        { label: 'The Vault', url: '/vault' }
      ]
    },
    {
      title: 'Support',
      links: [
        { label: 'Contact Us', url: '/support?section=contact' },
        { label: 'Returns & Exchanges', url: '/support?section=returns' },
        { label: 'FAQ', url: '/support?section=faq' }
      ]
    },
    {
      title: 'About',
      links: [{ label: 'Our Story', url: '/story' }]
    }
  ],
  instagramUrl: 'https://instagram.com/4hvnsk8',
  copyrightName: '4HVNSK8',
  bottomLinks: [
    { label: 'PRIVACY POLICY', url: '/support?section=privacy' },
    { label: 'TERMS OF USE', url: '/support?section=terms' }
  ]
};

